export default "__VITE_ASSET__DrPy1RS3__"